import { BehaviorSubject } from 'rxjs';

import ConfirmNoSelectedStudy from '../containers/downgrade/ConfirmNoSelectedStudy';
import PatientRecord from '../models/PatientRecord';

export default class DowngradeBloc {
  records$ = new BehaviorSubject(null);
  checkedStudies = [];
  downloadProcessed$ = new BehaviorSubject(false);

  constructor({ dialogRepository, paymentRepository, patientRepository, userRepository, errorRepository }) {
    this.dialogRepository = dialogRepository;
    this.paymentRepository = paymentRepository;
    this.patientRepository = patientRepository;
    this.userRepository = userRepository;
    this.errorRepository = errorRepository;
  }

  get planCount() {
    const plan = this.paymentRepository.planToDowngrade$.getValue();
    switch (plan?.name) {
      case 'basic':
        return 3;
      case 'standard':
        return 10;
      default:
        break;
    }
    return 0;
  }

  setStudiesToRemove(studiesToKeep) {
    const idsToKeep = studiesToKeep.map((item) => item.id);
    const studiesToRemove = this.records$.getValue().filter((item) => idsToKeep.indexOf(item.id) === -1);
    this.paymentRepository.studiesToRemove$.next(studiesToRemove);
  }

  confirmNoSelection() {
    this.dialogRepository.loadDialog(ConfirmNoSelectedStudy, {
      onCancelClick: () => this.dialogRepository.toggleDialog(false),
      onContinueClick: async () => {
        this.setStudiesToRemove([]);
        await this.continueDowngrade();
      },
    });
  }

  async getDowngradeRecords() {
    const records = await this.patientRepository.getPatientRecords();
    this.records$.next(records.data.map((record) => new PatientRecord(record)));
  }

  async continueDowngrade() {
    const studiesToRemove = this.paymentRepository.studiesToRemove$.getValue()?.map((item) => item.id);
    if (!studiesToRemove) return;

    const plan = this.paymentRepository.planToDowngrade$.getValue();
    if (plan) {
      await this.patientRepository.deleteRecords(studiesToRemove);
      if (plan.isPackage) {
        await this.createPackageCheckoutSession(plan);
      } else {
        await this.createSubscriptionCheckoutSession(plan);
      }
    }
  }

  async downloadUnwantedStudies() {
    const studiesToRemove = this.paymentRepository.studiesToRemove$.getValue()?.map((e) => e.id);
    if (!studiesToRemove) return;

    await this.patientRepository.downloadDowngradeFiles(studiesToRemove);
    this.downloadProcessed$.next(true);
    this.errorRepository.error$.next({ message: 'You will get an email when your download is ready', severity: 'success' });
  }

  async redirectToCheckout(sessionId) {
    return this.paymentRepository.redirectToCheckout(sessionId);
  }

  async createSubscriptionCheckoutSession(plan) {
    const { sessionId } = await this.paymentRepository.createSubscriptionCheckoutSession(plan.name);
    const result = await this.redirectToCheckout(sessionId);
    if (result.error) {
      console.log('createSubscriptionCheckoutSession error', result.error);
    }
  }

  async createPackageCheckoutSession(plan) {
    const { sessionId } = await this.paymentRepository.createPackageCheckoutSession(plan.name);
    const result = await this.redirectToCheckout(sessionId);
    if (result.error) {
      console.log('createPackageCheckoutSession error', result.error);
    }
  }
}
